import React from "react";
import { PRODUCTION_ORIGIN } from "@/lib/seo";

// ============================================================
// FYUNOR — SeoMeta
// Renders SEO tags (<title>, <meta>, <link>, JSON-LD) as React
// elements so they are captured by the platform's prerenderer
// and present in the server-rendered HTML crawlers receive.
// (React 18 does not hoist these to <head>, but search engines
//  and social scrapers read them anywhere in the document.)
// ============================================================

const DEFAULT_OG_IMAGE =
  "https://media.base44.com/images/public/6a7629cb4dcda6ad3ef679a6/41e9201e3_Fyunor-og-image.png";

function toAbsoluteUrl(path) {
  if (!path) return undefined;
  return path.startsWith("http") ? path : `${PRODUCTION_ORIGIN}${path}`;
}

export default function SeoMeta({
  title,
  description,
  canonical,
  openGraph,
  twitter,
  robots,
  structuredData,
}) {
  const og = openGraph || {};
  const tw = twitter || {};
  const canonicalUrl = toAbsoluteUrl(canonical);
  const ogImage = og.image || DEFAULT_OG_IMAGE;

  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonicalUrl} />}
      {robots && <meta name="robots" content={robots} />}
      <meta property="og:title" content={og.title || title} />
      <meta property="og:description" content={og.description || description} />
      <meta property="og:type" content={og.type || "website"} />
      <meta property="og:site_name" content={og.siteName || "Fyunor"} />
      {canonical && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content={tw.card || "summary_large_image"} />
      <meta name="twitter:title" content={tw.title || title} />
      <meta name="twitter:description" content={tw.description || description} />
      <meta name="twitter:image" content={tw.image || ogImage} />
      {structuredData?.map((schema, i) =>
        schema ? (
          <script
            key={i}
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
          />
        ) : null
      )}
    </>
  );
}